import axios from "axios";
import * as endpoints from "./const";

class DashboardApi {
  static fetchProfile(fetchParams, id, type) {
    let endpointUrl;
    switch (type) {
      case "driver":
        endpointUrl = `${endpoints.DRIVER_PROFILE}/${id}`;
        break;
      case "vehicle":
        endpointUrl = `${endpoints.VEHICLE_PROFILE}/${id}`;
        break;
      default:
        console.error("Invalid type option");
        throw "Invalid type option in Dashboard";
    }

    return axios
      .get(endpointUrl, {
        params: fetchParams
      })
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }

  static getReportData(reportParams) {
    let endpointUrl;

    switch (reportParams.type) {
      case "driver":
        endpointUrl = `${endpoints.DRIVER_DASHBOARD_REPORT_TILE}`;
        break;
      case "vehicle":
        endpointUrl = `${endpoints.VEHICLE_DASHBOARD_REPORT_TILE}`;

        break;
      default:
        console.error("Invalid type option");
        throw "Invalid type option in Dashboard";
    }

    return axios
      .get(endpointUrl, {
        params: reportParams
      })
      .then(response => response.data)
      .then(data => {
        return data;
      })
      .catch(error => {
        throw error;
      });
  }

  static fetchProfileNotes(fetchParams, id, type) {
    let endpointUrl;
    let params;

    switch (type) {
      case "driver":
        endpointUrl = `${endpoints.DRIVER_NOTES}`;
        params = { driverId: id, ...fetchParams };

        break;
      case "vehicle":
        endpointUrl = `${endpoints.VEHICLE_NOTES}`;
        params = { leaseId: id, ...fetchParams };
        break;
      default:
        console.error("Invalid type option");
        throw "Invalid type option in Dashboard";
    }

    return axios
      .get(endpointUrl, {
        params
      })
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }

  static getReportDetails(reportParams) {
    const endpointUrl = reportParams.fetchVehicleInfoDetail
      ? endpoints.VEHICLE_DASHBOARD_INFO_DETAIL
      : endpoints.DRIVER_DASHBOARD_REPORT_DETAIL;

    return axios
      .get(endpointUrl, {
        params: reportParams
      })
      .then(response => response.data)
      .then(data => {
        return data;
      })
      .catch(error => {
        throw error;
      });
  }

  static getVehicleSummary(cardParams) {
    return axios
      .get(endpoints.DRIVER_DASHBOARD_VEHICLE_SUMMARY, {
        params: cardParams
      })
      .then(response => response.data)
      .then(data => {
        return data;
      })
      .catch(error => {
        throw error;
      });
  }

  static getDriverSummary(cardParams) {
    return axios
      .get(endpoints.VEHICLE_DASHBOARD_DRIVER_SUMMARY, {
        params: cardParams
      })
      .then(response => response.data)
      .then(data => {
        return data;
      })
      .catch(error => {
        throw error;
      });
  }

  static getCardSummary(cardParams) {
    return axios
      .get(endpoints.DRIVER_DASHBOARD_CARD_SUMMARY, {
        params: cardParams
      })
      .then(response => response.data)
      .then(data => {
        return data;
      })
      .catch(error => {
        throw error;
      });
  }

  static getCardDetails(cardParams) {
    return axios
      .get(endpoints.DRIVER_DASHBOARD_CARD_DETAIL, {
        params: cardParams
      })
      .then(response => response.data)
      .then(data => {
        return data;
      })
      .catch(error => {
        throw error;
      });
  }

  static getVehicleHistoryDetails(leaseId) {
    return axios
      .get(`${endpoints.DRIVER_DASHBOARD_VEHICLE_HISTORY}/${leaseId}`)
      .then(response => response.data)
      .then(data => {
        return data;
      })
      .catch(error => {
        throw error;
      });
  }

  static addNotes(id, Note, type) {
    let endpointUrl;
    let params;

    switch (type) {
      case "driver":
        endpointUrl = `${endpoints.DRIVER_NOTES}`;
        params = { DriverId: id, Note };

        break;
      case "vehicle":
        endpointUrl = `${endpoints.VEHICLE_NOTES}`;
        params = { LeaseId: id, Note };
        break;
      default:
        console.error("Invalid type option");
        throw "Invalid type option in Dashboard";
    }
    axios
      .post(endpointUrl, params)
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }

  static bookmark(id, Marked, type) {
    let endpointUrl;
    let params;

    switch (type) {
      case "driver":
        endpointUrl = `${endpoints.BOOKMARKS_DRIVER}`;
        params = { DriverId: id, Marked };

        break;
      case "vehicle":
        endpointUrl = `${endpoints.BOOKMARKS_VEHICLE}`;
        params = { LeaseId: id, Marked };
        break;
      default:
        console.error("Invalid type option");
        throw "Invalid type option in Dashboard";
    }

    axios
      .put(endpointUrl, params)
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }
}

export default DashboardApi;



// WEBPACK FOOTER //
// ./src/api/DashboardApi.js